import React, { useState, useEffect } from "react";
import { Tooltip } from "reactstrap";
import { useVsiAppContext } from "../stores/VsiApp";
import themeStyles, { textWhite } from "../utils/themeStyles";
import { useDebounce } from "../utils/hooks";
import { DeleteAuth, PostAuth } from "../utils/Verbs";
import { useSearchParams } from "react-router-dom";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

function FavoriteButton({ route }) {

  const { context, path, title } = route;
  const {
    theme,
    client,
    user,
    getAccessTokenSilently,
    setAllFavoritesItems,
    setUser,
  } = useVsiAppContext();
  const [foundFavorite, setFoundFavorite] = useState(user.favorites?.find?.(fav => fav.path === path) ?? null);

  const [searchParams] = useSearchParams();
  const [isHovering, setIsHovering] = useState(false);
  const [isToolTipOpen, setIsToolTipOpen] = useState(false);

  const debouncedToolTipOpen = useDebounce(isHovering, 1000);

  useEffect(() => {
    if (user.favorites) {
      setFoundFavorite(user.favorites.find(fav => {
        return fav.path === path && fav.params.every(({ param, value }) => {
          return decodeURIComponent(searchParams.get(param)) === value;
        });
      }));
    }
  }, [user.favorites, path, searchParams]);

  useEffect(() => {
    if (isHovering && debouncedToolTipOpen) {
      setIsToolTipOpen(true);
    } else if (!isHovering) {
      setIsToolTipOpen(false);
    }
  }, [debouncedToolTipOpen, isHovering]);

  const determineBookmarkColor = () => {
    if (foundFavorite?.path) return isHovering ? "regular" : "solid";
    return isHovering ? "solid" : "regular";
  };

  const btnStyle = {
    // background: themeStyles[theme].reportBtnBg,
    // borderColor: textWhite,
    cursor: "pointer",
    color: textWhite
  };

  const onClick = async () => {
    const token = await getAccessTokenSilently();
    if (!foundFavorite) {
      const params = [];
      searchParams.forEach((value, key) => {
        if (key !== "period_id") {
          params.push({
            param: key,
            value
          });
        }
      });

      const favorite = {
        user: user._id,
        client: client._id,
        path,
        context,
        title,
        params
      };
      try {
        const saveFav = await PostAuth("/api/v6/admin/favorite", favorite, token);
        if (saveFav?.data?.data) {
          setUser(user => {
            return {
              ...user,
              favorites: [...user.favorites, saveFav?.data?.data],
            }
          })
          setAllFavoritesItems(allFavs => [...allFavs, saveFav?.data?.data]);
        }
      } catch (error) {
        console.error(error);
      }

    } else {
      try {
        const deleteFav = await DeleteAuth(`/api/v6/admin/favorite/${user._id}/${foundFavorite._id}`, token);
        if (deleteFav) {
          setUser(user => {
            return {
              ...user,
              favorites: user.favorites.filter(route => route._id !== foundFavorite._id),
            }
          })
          setAllFavoritesItems(allFavs => allFavs.filter(route => route._id !== foundFavorite._id));
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  return <h4 style={btnStyle}
             className={"report-util-btn"}
             id={"favorite-btn"}
             onClick={onClick}
             onMouseLeave={() => setIsHovering(false)}
             onMouseEnter={() => setIsHovering(true)}>
    <>
      <i className={`fa-${determineBookmarkColor()} fa-bookmark report-util-icon`}
         style={{ color: themeStyles[theme].vsiPupil }} />
      <Tooltip
        isOpen={isToolTipOpen}
        target="favorite-btn"
        // toggle={toggle}
      >
        {foundFavorite?.path ? "Remove this report from your home screen" : "Add this report to your home screen"}
      </Tooltip>
    </>
  </h4>;
}

export default withErrorBoundary(FavoriteButton, GeneralErrorBoundary);
